import { FC, ReactNode } from 'react';

interface StatisticsCardProps {
  icon: ReactNode | null;
  label: string;
  count: number;
  countColor?: string;
}

export const StatisticsCard: FC<StatisticsCardProps> = ({
  icon,
  label,
  count,
  countColor = 'text-green-green-700',
}) => {
  return (
    <div className="flex p-[12px] gap-[12px] w-[180px] bg-white rounded-[10px] border border-gray-smoke items-center justify-start">
      {icon}
      <div className="flex flex-col items-start justify-between">
        <span className="text-[14px] text-gray-phantom">{label}</span>
        <span className={`text-[24px] font-bold ${countColor}`}>{count}</span>
      </div>
    </div>
  );
};

